import { createFileRoute } from "@tanstack/react-router";
import { PortalLayout } from "@/components/app/portal/shell/portal-layout";

export const Route = createFileRoute("/resident-portal")({
  component: ResidentPortalRoute,
});

/** Everything under /resident-portal sits in the portal's shell, which signs the reader in once. */
function ResidentPortalRoute() {
  return <PortalLayout kind="resident" />;
}
